import { createAction } from '@reduxjs/toolkit';
import { Account } from 'api/account';

export const fetchAccountSagaAction = createAction('account/getAccount');

export interface SaveAccountPayload {
  account: AtLeast<Account, 'accountId'>;
  handleSuccess?(): void;
  handleError?(): void;
  handleAlways?(): void;
}
export const saveAccountSagaAction = createAction<SaveAccountPayload>(
  'account/saveAccount',
);
